import React from 'react';
import { Headline3, Hint, EmptyStateIcon } from 'venn-ui-kit';

interface EmptyStateProps {
  onClear: () => void;
  canClearQuery: boolean;
  canClearFilters: boolean;
}

const EmptyStateV2 = ({ onClear, canClearQuery, canClearFilters }: EmptyStateProps) => {
  let action = 'Reset all filters';
  // We should never reach the empty state without one of canClearQuery and canClearFilters being true
  // because there will always be Venn system investments.
  if (canClearQuery && canClearFilters) {
    action += ' and clear query';
  } else if (canClearQuery) {
    action = 'Clear query';
  }

  return (
    <div className="text-center mt-[60px] font-bold">
      <EmptyStateIcon />
      <Headline3 center>No items found</Headline3>
      <Hint data-testid="qa-empty-state">
        <button
          type="button"
          className="qa-clear-filters text-venn-primary-dark"
          data-testid="qa-clear-filters"
          onClick={onClear}
        >
          {action}
        </button>{' '}
        to search your entire library
      </Hint>
    </div>
  );
};

export default EmptyStateV2;
